import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import {
  isAttendeeReadChannel,
  isNotificationChannel,
  isRemindNotificationChannel,
  formatNotification,
  formatReminder
} from './utils';

const LOG = LoggerFactory.create('messageEventHandler');

/**
 * Method is used to handle message event of pubNub
 */
export const messageEventHandler = ({
  subscriptionMessage,
  addNotifications,
  markNotificationsAsRead,
  addReminders,
  seamlessTransitionToastFake = false
}) => {
  const { channel: channelName, message, timetoken } = subscriptionMessage;
  if (isAttendeeReadChannel(channelName)) {
    const { announcementIds: notificationIds } = message;
    markNotificationsAsRead(notificationIds);
  } else if (isRemindNotificationChannel(channelName)) {
    const reminder = formatReminder({
      channelName,
      entry: message,
      timetoken
    });
    if (reminder) {
      addReminders([reminder]);
    }
  } else if (isNotificationChannel(channelName)) {
    const notification = formatNotification({
      channelName,
      entry: message,
      timetoken
    });

    addNotifications([notification]);

    // Included to provide the ability to test seamless transition toast more easily
    if (
      seamlessTransitionToastFake &&
      notification.title === 'SEAMLESS_TRANSITION_FAKE'
    ) {
      const reminder = formatReminder({
        channelName,
        entry: message,
        timetoken
      });
      if (reminder) {
        addReminders([reminder]);
      }
    }
  } else {
    const errorMessage = `No message event handler found for channel ${channelName}`;
    LOG.error(errorMessage, {
      subscriptionMessage
    });
    throw new Error(errorMessage);
  }
};
